import { Injectable } from '@angular/core';

import { DatePickerDateType, DateTypeLocale, DateTypeOption } from '@roomex/rx-components';

interface Translation {
  [key: string]: string;
}

enum ReportDateTypes {
  All = 'all',
  Booking = 'booking',
  CheckIn = 'check-in',
  CheckOut = 'check-out'
}

@Injectable({ providedIn: 'root' })
export class DateTypeOptionsService {
  private readonly bookingOption: DateTypeOption[] = [{ key: ReportDateTypes.Booking, name: 'Booking' }];
  private readonly checkinOption: DateTypeOption[] = [{ key: ReportDateTypes.CheckIn, name: 'Check-in' }];
  private readonly allOptions = [
    { key: ReportDateTypes.Booking, name: 'Booking' },
    { key: ReportDateTypes.CheckIn, name: 'Check-in' },
    { key: ReportDateTypes.CheckOut, name: 'Check-out' }
  ];

  getDateType(translations: Translation, exclusiveDateType: ReportDateTypes = ReportDateTypes.All): DatePickerDateType[] {
    return (
      new Map<ReportDateTypes, DatePickerDateType[]>([
        [ReportDateTypes.All, this.getAllTypes(translations)],
        [ReportDateTypes.Booking, this.getBookingType(translations)],
        [ReportDateTypes.CheckIn, this.getCheckinType(translations)]
      ]).get(exclusiveDateType) || this.getAllTypes(translations)
    );
  }

  private getAllTypes(translation: Translation): DatePickerDateType[] {
    return this.allOptions.map(dateType => this.mapToObject(dateType, translation));
  }

  private getBookingType(translation: Translation | DateTypeLocale) {
    return this.bookingOption.map(dateType => this.mapToObject(dateType, translation));
  }

  private getCheckinType(translation: Translation | DateTypeLocale) {
    return this.checkinOption.map(dateType => this.mapToObject(dateType, translation));
  }

  private mapToObject(dateType: DateTypeOption, translation: Translation | DateTypeLocale): DatePickerDateType {
    return {
      ...dateType,
      id: dateType.key,
      name: translation[dateType.key]
    };
  }
}
